import { render } from "./Leitung.vue?vue&type=template&id=472ea1a3"
import script from "./Leitung.vue?vue&type=script&lang=js"
export * from "./Leitung.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__